// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullRegattaResultOverall,
  $Model,
} from 'common.data';

// Global Enums
import {
  webPages,
  webSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  scrollTop,
} from '@vroskus/library-helpers/dist/browser';

// Services
import Services from '../../../../services';

// Components
import Section from '../../../layout/Section';
import Loader from '../../../layout/Loader';
import RegattaResultOverallTable from '../../../common/RegattaResultOverallTable';

// Types
type $Props = $Translate & {
  item: $Model<'Regatta'>;
};

type $State = {
  data: Array<$FullRegattaResultOverall>;
  loading: boolean;
};

class ResultsOverallSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      data: [],
      loading: false,
    };
  }

  componentDidMount(): void {
    this.getData();
    this.setupSocket();
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async getData(): Promise<void> {
    const {
      item,
    } = this.props;

    try {
      await this.setStateAsync({
        loading: true,
      });

      const data = await Services.Api.getRegattaResultsOverallSectionData({
        RegattaId: item.id,
      });

      await this.setStateAsync({
        data,
        loading: false,
      });
    } catch (error) {
      await this.setStateAsync({
        loading: false,
      });

      ErrorLog.exception(error as Error);
    }
  }

  setupSocket(): void {
    const {
      item,
    } = this.props;

    Services.Socket.on({
      action: (data) => {
        if (data.RegattaId === item.id && data.modelName === 'RegattaResultOverall') {
          this.getData();
        }
      },
      type: Services.Socket.type.modelChangedEvent,
    });
  }

  render() {
    const {
      item,
      t,
    } = this.props;
    const {
      data,
      loading,
    } = this.state;

    return (data.length > 0 ? (
      <Section
        id={webSections[webPages.regattaPage].resultsOverall}
        title={t('Overall results')}
        transparent
      >
        <Loader
          fade
          loading={loading === true}
        >
          <div className={'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 -mx-5 -mb-5'}>
            {data.map((dataItem: $FullRegattaResultOverall) => (
              <div
                className={'bg-white rounded-lg px-5 pb-2'}
                key={dataItem.id}
              >
                <RegattaResultOverallTable
                  item={dataItem}
                  onShowLess={() => scrollTop(webSections[webPages.regattaPage].resultsOverall)}
                  regatta={item}
                />
              </div>
            ))}
          </div>
        </Loader>
      </Section>
    ) : null);
  }
}

export default ResultsOverallSectionView;
